<img
  *ngIf="photo && photo.thumbnail && photo.folder; else placeholder"
  [hfSrcset]="photo.folder + '/' + photo.thumbnail"
  (error)="photo = undefined"
/>

<ng-template #placeholder>
  <img src="assets/img/avatar-placeholder.png" />
</ng-template>
